import { Modal, message } from 'antd';
import { FC, useState } from 'react';
import { AddButton } from '../../../../../lib/components/Buttons/AddButton';
import { InputItem } from '../../../../../lib/components/InputItem';
import { InsertSearchTagDto } from '../dto/SearchTagDto';
import { useSearchTagsApi } from '../hooks/SearchTagsApi';

interface IProps {
	visible: boolean;
	close: () => void;
	insert_success: () => void;
	prefix: string;
	tag_name_in_portuguese: string;
}

export const SearchTagInsertModal: FC<IProps> = ({
	visible,
	close,
	insert_success,
	prefix,
	tag_name_in_portuguese,
}) => {
	const [tag_title, set_tag_title] = useState('');
	const [loading, set_loading] = useState(false);
	const { insert } = useSearchTagsApi();

	const submit = async (dto: InsertSearchTagDto) => {
		if (!dto.title) return;

		// Separar tags por ponto e vírgula e remover espaços extras nas extremidades
		const tags = dto.title
			.split(';')
			.map((t) => t.trim())
			.filter((t) => t.length > 0);

		if (tags.length === 0) {
			message.warning('Digite pelo menos uma tag válida.');
			return;
		}

		// Regex para validar cada tag individualmente: letras, números e espaços
		const tagRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ0-9\s.,\/ºª°-]+$/u;
		const invalidTags = tags.filter((tag) => !tagRegex.test(tag));

		if (invalidTags.length > 0) {
			message.error(`As seguintes tags são inválidas: ${invalidTags.join(', ')}`);
			return;
		}

		set_loading(true);

		try {
			for (const tag of tags) {
				try {
					await insert.create({ title: tag, prefix: dto.prefix });
					message.success(`Tag "${tag}" criada com sucesso!`);
				} catch (err) {
					console.error(`Erro ao criar tag "${tag}":`, err);
					message.error(`Erro ao criar a tag "${tag}".`);
				}
			}

			insert_success();
			close();
			set_tag_title('');
		} finally {
			set_loading(false);
		}
	};

	return (
		<Modal
			{...{
				visible,
				centered: true,
				closable: true,
				destroyOnClose: true,
				onCancel: () => close(),
				title: `Criar ${tag_name_in_portuguese}`,
				footer: [
					<AddButton
						{...{
							onClick: () => submit({ title: tag_title, prefix }),
							disabled: !tag_title || loading,
							loading,
						}}
					/>,
				],
			}}
		>
			<InputItem
				{...{
					label: 'Título',
					on_changed: set_tag_title,
					input_item_name: tag_title,
				}}
			/>
			<small style={{ color: '#888' }}>
				Digite várias tags usando apenas <b>letras</b> e separando com <b>ponto e vírgula(;)</b>.<br />
				Ex: Autor(es): <i>João Souza;Maria dos Santos;José da Silva...</i>
				<br />
				Palavra(s)-chave: <i>Administrativo;Crimes eleitorais;Licitações...</i>
			</small>
		</Modal>
	);
};
